<template>
  <!-- Main wrapper -->
  <div class="invoice-wrapper">
    <!-- Download button -->
    <div
      class="no-print"
      style="text-align: center; margin: 20px"
    >
      <button
        class="download-btn"
        @click="exportToPDF"
      >
        Download Final Invoice
      </button>
    </div>

    <!-- Invoice content (this will be converted to PDF) -->
    <div
      ref="invoice"
      class="invoice-container"
    >
      <!-- Header image -->
      <div class="header-img">
        <img
          :src="frontImg"
          class="full-width"
          alt="Header"
        >
      </div>

      <!-- Main content area -->
      <div class="main-content">
        <!-- Top section (Client + Invoice info) -->
        <div class="info-grid">
          <!-- Client details -->
          <div class="bill-section">
            <h2 class="label-navy">
              BILL TO:
            </h2>
            <div class="client-data">
              <p class="name-bold">
                {{ invoice.student }}
              </p>
              <p class="sub-text">
                {{ invoice.phone }}
              </p>
            </div>
          </div>

          <!-- Invoice details -->
          <div class="invoice-section">
            <h2 class="label-navy">
              INVOICE : #{{ invoice.invoice_no }}
            </h2>
            <p class="sub-text date-text">
              {{ momentTimestampFormat(invoice.date, "YYYY-MM-DD") }}
            </p>
          </div>
        </div>

        <!-- Payment table -->
        <div class="table-container">
          <!-- Table header -->
          <div class="pill-header">
            <div class="desc-col">
              DESCRIPTION
            </div>
            <div class="amount-col text-navy">
              AMOUNT(RS)
            </div>
          </div>
          <!-- Table row -->
          <div class="table-row">
            <div class="desc-val">
              Course Payment
            </div>
            <div class="amount-val">
              {{ getPrice(invoice.amount) }}
            </div>
          </div>
        </div>

        <!-- Summary section -->
        <div class="summary-wrapper">
          <div class="summary-box">
            <!-- Paid amount -->
            <div class="s-line">
              <span class="s-label">Paid Amount</span>
              <span class="s-value">{{ getPrice(invoice.amount) }}</span>
            </div>
            <div class="divider-white" />

            <!-- Full paid amount -->
            <div class="s-line">
              <span class="s-label">Full Paid Amount</span>
              <span class="s-value">{{ getPrice(invoice.paid) }}</span>
            </div>

            <!-- Due amount -->
            <div class="s-line">
              <span class="s-label">Due Amount</span>
              <span class="s-value">{{ getPrice(invoice.due) }}</span>
            </div>

            <!-- Total highlight -->
            <div class="gold-total-bar text-navy">
              <span class="total-label">FULL TOTAL</span>
              <span class="total-price">{{ getPrice(invoice.total) }}</span>
            </div>
          </div>
        </div>

        <!-- Footer details -->
        <div class="footer-details">
          <div class="payment-method-section">
            <div class="payment-badge">
              <span class="dot" />
              <span class="badge-text">Payment Method:</span>
            </div>

            <!-- Bank details -->
            <div class="bank-details">
              <p><b>Bank Name :</b> Hatton National bank</p>
              <p><b>Account Name :</b> AIO-IT SOLUTIONS (PRIVATE) LIMITED</p>
              <p><b>Account Number -</b> 084020346571</p>
              <p><b>Branch -</b> KADAWATHA BRANCH</p>
            </div>
          </div>

          <!-- Signature section -->
          <div class="signature-section">
            <div class="sig-wrapper">
              <img
                src="/signature.png"
                class="sig-img"
                alt="Signature"
              >
              <div class="sig-dots" />
              <p class="sig-title">
                Director & Ceo
              </p>
              <p class="sig-company">
                AIO-IT SOLUTIONS PVT(LTD)
              </p>
            </div>

            <!-- Thank you text -->
            <h1 class="thank-you">
              Thank You
            </h1>
          </div>
        </div>
      </div>

      <!-- Bottom footer -->
      <div class="footer-fixed">
        <!-- Divider -->
        <div class="footer-divider" />

        <!-- Contact details -->
        <div class="contact-info">
          <p class="address-text">
            No.291/4 , Ranaviru Dharmasiri Mawatha , Sooriyapaluwa , Kadawatha
            ,Gampaha
          </p>
          <div class="contact-row">
            <!-- Phone -->
            <div class="contact-item">
              <svg
                class="gold-svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27c1.12.45 2.33.69 3.58.69a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.24 2.46.69 3.58a1 1 0 01-.27 1.11l-2.2 2.2z"
                />
              </svg>
              <span>+94 71 345 3110</span>
            </div>

            <!-- Email -->
            <div class="contact-item">
              <svg
                class="gold-svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                />
              </svg>
              <span>aio99solutions@gmail.com</span>
            </div>
          </div>
        </div>
        <!-- Bottom bar -->
        <div class="bottom-gold-bar" />
      </div>
    </div>
  </div>
</template>

<script>
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import paymentApi from '@/Api/Modules/payment'

export default {
  data() {
    return {
      // Header image
      frontImg: '/front.png',
      // Invoice data
      invoice: {
        invoice_no: '',
        id: '',
        student: '',
        phone: '',
        date: '',
        amount: '0.00',
        paid: '0.00',
        due: '0.00',
        total: '0.00',
      },
      loading: true,
    }
  },
  mounted() {
    // Get URL ID
    const { id } = this.$route.params
    if (id) {
      this.getInvoiceDetails(id)
    }
  },
  methods: {
    // get invoice details
    async getInvoiceDetails(id) {
      try {
        const res = await paymentApi.getInvoice(id)
        this.invoice = res.data.data
        this.loading = false
      } catch (error) {
        console.error('Error fetching invoice:', error)
        this.loading = false
      }
    },
    // Convert invoice to PDF
    async exportToPDF() {
      const element = this.$refs.invoice
      // Convert HTML to canvas
      const canvas = await html2canvas(element, {
        scale: 3,
        useCORS: true,
        backgroundColor: '#ffffff',
        windowHeight: element.scrollHeight,
      })
      // Convert canvas to image
      const imgData = canvas.toDataURL('image/jpeg', 1.0)
      // Create PDF
      const pdf = new jsPDF('p', 'mm', 'a4')
      // Add image to PDF
      pdf.addImage(imgData, 'JPEG', 0, 0, 210, 297, undefined, 'FAST')

      // Download PDF
      // if student pay via instalment
      if (this.invoice.type == 'Instalment Payment') {
        pdf.save(
          `${this.invoice.student} - Training Course Payments(Instalment ${this.invoice.instalment}).pdf`,
        )
      }
      // if student pay via one time
      else {
        pdf.save(
          `${this.invoice.student} - Training Course Payments(OneTime).pdf`,
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/invoice.scss";
</style>
